import get from 'lodash/get';

/**
 * Extend from Error and re-establish the prototype chain.
 * New error types can be defined by extending this class.
 * https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
 */
class BaseError extends Error {
  constructor(message?: string) {
    super(message);
    if (typeof Object.setPrototypeOf === 'function') {
      Object.setPrototypeOf(this, new.target.prototype);
    } else {
      (this as any).__proto__ = new.target.prototype; // eslint-disable-line @typescript-eslint/no-explicit-any
    }
  }
}

export class DuplicateGroupError extends BaseError {}

export function getApiErrorMessage(error: Error): string {
  return get(error, 'error.message');
}

export function extractServerErrorMessage(err: unknown): string | null {
  try {
    const body = (err as { error?: unknown })?.error;
    if (!body) {
      return null;
    }

    // FastAPI validation error: { detail: [{ msg: 'Value error, ...' }] }
    const detail = (body as { detail?: Array<{ msg?: string }> })?.detail;
    if (Array.isArray(detail) && detail.length > 0) {
      const messages = detail.map((d) => d.msg?.replace(/^Value error,\s*/i, '').trim()).filter(Boolean);
      if (messages.length > 0) {
        return messages.join('; ');
      }
    }

    const message = (body as { message?: string })?.message;
    if (!message) {
      return null;
    }

    // Python-formatted validation string: {'msg': 'Value error, ...'}
    const match = message.match(/'msg':\s*'([^']+)'/);
    if (match) {
      return match[1].replace(/^Value error,\s*/i, '').trim();
    }

    return message;
  } catch {
    return null;
  }
}
